import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAnalytics } from '../hooks/useAnalytics';
interface FloatingCTAProps {
  ctaText?: string;
  ctaLink: string;
  subText?: string;
}
export function FloatingCTA({
  ctaText = 'Try GINEXT Risk-Free',
  ctaLink,
  subText = '30-Day Money Back Guarantee'
}: FloatingCTAProps) {
  const [isVisible, setIsVisible] = useState(false);
  const [bundlesVisible, setBundlesVisible] = useState(false);
  const {
    trackClick
  } = useAnalytics();
  // Track scroll percentage
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrollPercentage = scrollTop / scrollHeight * 100;
      // Show after 20% scroll AND bundles section not visible
      setIsVisible(scrollPercentage > 20 && !bundlesVisible);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [bundlesVisible]);
  // Track bundles section visibility
  useEffect(() => {
    const bundlesSection = document.getElementById('bundles');
    if (!bundlesSection) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        setBundlesVisible(entry.isIntersecting);
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px' // Hide CTA slightly before reaching section
    });
    observer.observe(bundlesSection);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-878">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 100
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 100
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-0 left-0 right-0 z-40 pointer-events-none" data-id="element-879">
          <div className="max-w-4xl mx-auto px-4 pb-4 sm:pb-6" data-id="element-880">
            <div className="bg-white border border-gray-200 rounded-lg shadow-2xl pointer-events-auto" data-id="element-881">
              <div className="px-4 py-3 sm:px-6 sm:py-4" data-id="element-882">
                <div className="flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-883">
                  {/* Text Content */}
                  <div className="text-center sm:text-left" data-id="element-884">
                    <p className="text-sm sm:text-base font-semibold text-gray-900 font-serif" data-id="element-885">
                      {ctaText}
                    </p>
                    <p className="text-xs text-gray-600 font-light" data-id="element-886">
                      {subText}
                    </p>
                  </div>

                  {/* CTA Button */}
                  <Link to={ctaLink} className="w-full sm:w-auto" data-id="element-887">
                    <motion.button whileHover={{
                  scale: 1.02
                }} whileTap={{
                  scale: 0.98
                }} onClick={() => trackClick({
                  location: 'floating_cta',
                  destination: ctaLink
                })} className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-2.5 bg-gray-900 text-white font-medium rounded-md hover:bg-gray-700 transition-colors text-sm" data-id="element-888">
                      Learn More
                      <ArrowRight className="w-4 h-4" data-id="element-889" />
                    </motion.button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}